import type { ComponentType, SVGProps } from 'react';

import { CostLogIcon, DashboardIcon, EquipmentIcon, EventIcon, KitchenIcon, LocationIcon, MenusIcon, OrdersIcon, PriceModifierIcon, SalesTrackingIcon, SourcesIcon, SuppliersIcon, UserIcon, UsersIcon } from '@/react/components/icons/primitives';
import { CalendarIcon } from '@icons/CalendarIcon';
import { InboxIcon } from '@/react/components/icons/InboxIcon';

import type { SidebarIconKey } from './types';

type IconComponent = ComponentType<SVGProps<SVGSVGElement>>;

// Maps each nav icon key to its primitive component. Concepts without a glyph
// of their own in the Figma icon sheet borrow the nearest one: Contacts wears
// the sheet's "User" person, Products the "Kitchen", Availability the
// "Calendar", Organisations the "Suppliers" storefront, Locations the
// "Location" pin. Flagged to design for dedicated glyphs.
export const ICON_MAP: Record<SidebarIconKey, IconComponent> = {
  dashboard: DashboardIcon,
  inbox: InboxIcon,
  people: UserIcon,
  contacts: UserIcon,
  organisations: SuppliersIcon,
  orders: OrdersIcon,
  events: EventIcon,
  priceModifiers: PriceModifierIcon,
  salesTracking: SalesTrackingIcon,
  scheduler: CalendarIcon,
  coordinator: LocationIcon,
  kitchen: KitchenIcon,
  menus: MenusIcon,
  capacities: CalendarIcon,
  product: KitchenIcon,
  costLog: CostLogIcon,
  suppliers: SuppliersIcon,
  users: UsersIcon,
  orderSources: SourcesIcon,
  equipment: EquipmentIcon,
  locations: LocationIcon,
};
